import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import Heading from '@bibliocommons/heading';

import VendorAttributionLabel from 'app/components/bibs/shared/VendorAttributionLabel';
import AuthorsList from '../AuthorsList';

import './SimilarAuthors.scss';

export default function SimilarAuthors({ authorSuggestions, trackClick }) {
  const source = authorSuggestions.first()?.get('providerName');

  if (authorSuggestions.size === 0) return null;

  return (
    <div className="cp-similar-authors">
      <div className="similar-authors-heading">
        <Heading tagName="h3" size="medium" variant>
          <FormattedMessage id="similar_authors" />
        </Heading>
        <VendorAttributionLabel name={source} />
      </div>
      <AuthorsList authors={authorSuggestions} handleClick={trackClick} />
    </div>
  );
}

SimilarAuthors.propTypes = {
  authorSuggestions: ImmutablePropTypes.list.isRequired,
  trackClick: PropTypes.func.isRequired
};
